interface AppConfig {
  apiBase: string;
  apimBase: string;
}

declare global {
  interface EnvType {
    APIM: {
      baseUrl: string;
    };
    API: {
      baseurl: string;
    };
    ENV: Env;
    MAX_FILE_UPLOAD_SIZE_IN_MB: number;
    ENABLE_FILE_UPLOAD: boolean;
    ALLOWED_FILE_EXTENSIONS: string[];
    ldClientId: string;
    recaptchaKey: string;
  }
  interface Window {
    _CMS_: EnvType;
    qbeTrack?: {
      meta: {
        appRegion: string;
        appPartner: string;
        appType: string;
        appName: string;
        appVersion: string;
        appEnv: string;
        dataLayerName: string;
      };
      engage: {
        lastElement: string | null;
        engagedElements: Array<string> | null;
        files: Array<string>;
      };
    };
    dataLayer: Array<object>;
  }
}
export const Env = {
  LOCAL: 'local',
  SIT: 'sit',
  UAT: 'uat',

  DEV_BAU: 'dev-bau',
  SIT_BAU: 'sit-bau',
  UAT_BAU: 'uat-bau',

  PERF: 'perf',
  PROD: 'prod',
} as const;

export type Env = (typeof Env)[keyof typeof Env];

const haveEnv = typeof window._CMS_ === 'object' && typeof window._CMS_.ENV !== typeof undefined;

export const getBaseURL = () => {
  const defaultApiBaseUrl = 'https://sit.api-ext.qbe.com.au';
  return window._CMS_?.API?.baseurl ?? defaultApiBaseUrl;
};

export const getAPIMBaseURL = () => {
  const defaultApiBaseUrl = 'https://dev.api-au.qbe.com/digital-address-api/v1';
  return window._CMS_?.APIM?.baseUrl ?? defaultApiBaseUrl;
};

export const GOOGLE_RECAPTCHA_SITE_KEY = window?._CMS_?.recaptchaKey ?? '6LdnYnobAAAAAP194y4KCE3F5p01dlQU2ptC7nmy';

export const MAX_FILE_UPLOAD_SIZE_IN_MB =
  typeof window._CMS_ === 'object' && typeof window._CMS_.MAX_FILE_UPLOAD_SIZE_IN_MB !== typeof undefined
    ? window._CMS_.MAX_FILE_UPLOAD_SIZE_IN_MB
    : 5;

const defaultConfig: AppConfig = {
  apiBase: getBaseURL(),
  apimBase: getAPIMBaseURL(),
};

const devConfig: AppConfig = {
  ...defaultConfig,
};

const prodConfig: AppConfig = {
  ...defaultConfig,
  // Get apiBase dynamically from origin of the environment
  // apiBase: `https://prf.api-ext.qbe.com.au`,
};

const config = process.env.NODE_ENV === 'production' ? prodConfig : devConfig;

export default { ...defaultConfig, ...config };

export const DECIMAL_SCALE = 2;
